const NEW_ACCOUNT_MAX_SIGN_IN_DELAY_MS = 5 * 60 * 1000;

export interface IAccountSignInTimes {
  createdAt: Date | null;
  lastSignInAt: Date | null;
}

export const isNewAccountSignIn = (
  account: IAccountSignInTimes | null | undefined
): boolean => {
  if (!account?.createdAt) {
    return false;
  }

  if (!account.lastSignInAt) {
    return true;
  }

  return (
    account.lastSignInAt.getTime() - account.createdAt.getTime() <=
    NEW_ACCOUNT_MAX_SIGN_IN_DELAY_MS
  );
};
